function cov_26wj1otp5i() {
  var path = "/app/src/components/pay-next-month-tab/pay-next-month-tab.tsx";
  var hash = "c7409aacc491dfeb6569f8379b7300f82714dfab";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/pay-next-month-tab/pay-next-month-tab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 12
        },
        end: {
          line: 12,
          column: 23
        }
      },
      "1": {
        start: {
          line: 13,
          column: 23
        },
        end: {
          line: 13,
          column: 38
        }
      },
      "2": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 14,
          column: 51
        }
      },
      "3": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 42
        }
      },
      "4": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 32
        }
      },
      "5": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 32
        }
      },
      "6": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 39,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "PayNextMonthTab",
        decl: {
          start: {
            line: 11,
            column: 16
          },
          end: {
            line: 11,
            column: 31
          }
        },
        loc: {
          start: {
            line: 11,
            column: 34
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 42
          },
          end: {
            line: 29,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 42
          },
          end: {
            line: 29,
            column: 59
          }
        }, {
          start: {
            line: 29,
            column: 63
          },
          end: {
            line: 29,
            column: 74
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c7409aacc491dfeb6569f8379b7300f82714dfab"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26wj1otp5i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26wj1otp5i();
import cn from 'classnames';
import React from 'react';
import { Typography } from 'src/components/v2/typography';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { useNextBillingDate } from 'src/hooks/use-next-billing-date';
import styles from './styles.css';
export function PayNextMonthTab() {
  cov_26wj1otp5i().f[0]++;
  var t = (cov_26wj1otp5i().s[0]++, useLocale());
  var _ref = (cov_26wj1otp5i().s[1]++, useAppContext()),
    currency = _ref.currency;
  var country = (cov_26wj1otp5i().s[2]++, COUNTRY_BY_CURRENCY_MAP[currency]);
  var billingDate = (cov_26wj1otp5i().s[3]++, useNextBillingDate());
  cov_26wj1otp5i().s[4]++;
  if (!billingDate) {
    cov_26wj1otp5i().b[0][0]++;
    cov_26wj1otp5i().s[5]++;
    return null;
  } else {
    cov_26wj1otp5i().b[0][1]++;
  }
  cov_26wj1otp5i().s[6]++;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    "data-test": "pay-next-month-tab"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('pay_next_month')), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    className: styles.badge
  }, t('no_down_payment'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    className: cn(styles.description, (cov_26wj1otp5i().b[1][0]++, country === 'KSA') && (cov_26wj1otp5i().b[1][1]++, styles.grey))
  }, t('no_interest_no_fees')), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    className: styles.dateDescription
  }, t('pay_in_full_in_one_bill_due', {
    date: "".concat(billingDate.day, " ").concat(billingDate.month)
  })));
}